import { createContext, useState, ReactNode } from 'react';
export interface FormContextType<T = void, F = void> {
  result: T | null;
  updateResult: (resultData: T | null) => void;
  form: F | Record<string, string>;
  updateForm: (formData: Record<string, string>) => void;
  isLoading: boolean;
  setLoading: (isLoading: boolean) => void;
  hasError: boolean;
  setError: (isLoading: boolean) => void;
  isReady: boolean;
  setIsReady: (isLoading: boolean) => void;
}

export const FormContext = createContext<FormContextType<unknown | null>>({
  result: null,
  form: {},
  isLoading: false,
  isReady: false,
  hasError: false,
  setIsReady: () => {
    throw new Error('setIsReady function must be overridden');
  },
  setLoading: () => {
    throw new Error('setLoading function must be overridden');
  },
  setError: () => {
    throw new Error('setError function must be overridden');
  },
  updateForm: () => {
    throw new Error('updateForm function must be overridden');
  },
  updateResult: () => {
    throw new Error('updateResult function must be overridden');
  }
});

export const FormProvider = <T,>({ children }: { children: ReactNode }) => {
  const [form, setForm] = useState({});
  const [result, setResult] = useState<T | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isReady, setIsReady] = useState<boolean>(false);
  const [hasError, setError] = useState<boolean>(false);

  function updateForm(formData: Record<string, string>) {
    //console.log(formData);
    setForm({
      ...form,
      ...formData
    });
  }

  function updateResult(resultData: T | null) {
    //console.log(`updateResult`, resultData);
    if (!resultData) {
      setResult(null);
      return;
    }
    setResult({
      ...result,
      ...resultData
    });
  }

  return (
    <FormContext.Provider
      value={{
        result,
        form,
        isLoading,
        hasError,
        isReady,
        setLoading,
        setError,
        setIsReady,
        updateForm,
        updateResult: updateResult as (resultData: unknown | null) => void
      }}>
      {children}
    </FormContext.Provider>
  );
};
